<template>
  <!--设计模式-->
  <div class="ds-control ds-lazy-box ds-no-padding" v-if="isDesign">
    <div slot-name="default" class="ds-lazy-box-inner">
      <slot></slot>
    </div>
  </div>
  <!--懒加载 start-->
  <transition-group
    v-else-if="support"
    :tag="tagName"
    name="lazy-component"
    :style="getStyle"
    class="ds-control ds-lazy-box ds-no-padding ds-lazy-box_support"
    @before-enter="beforeEnterHandler"
    @before-leave="beforeLeaveHandler"
    @after-enter="afterEnterHandler"
    @after-leave="afterLeaveHandler">
    <template v-if="useDefaultSlot">
      <div v-if="inClient" key="component" :class="$innerClass">
        <slot :loading="loading"></slot>
      </div>
      <div v-else-if="$slots.skeleton" key="skeleton">
        <slot name="skeleton"></slot>
      </div>
    </template>
    <template v-else>
      <slot :loading="loading" v-if="inClient" :class="$innerClass"></slot>
    </template>
  </transition-group>
  <!--懒加载 end-->
  <!--不支持懒加载的浏览器-->
  <div class="ds-control ds-lazy-box ds-no-padding" v-else>
    <slot></slot>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfLazyBox",
  mixins: [$mixins.layout],
  ctrlCaption: "懒加载",
  props: {
    slots: {
      type: Array,
      default() {
        return [{ name: "default", controls: [] }];
      }
    },
    timeout: {
      type: Number,
      default: 0
    },
    tagName: {
      type: String,
      default: "div"
    },
    viewport: {
      type: Object, //typeof window !== "undefined" ? window.HTMLElement : Object,
      default: () => null
    },
    threshold: {
      type: [Number, String],
      default: 0
    },
    direction: {
      type: String,
      default: "vertical"
    },
    maxWaitingTime: {
      type: Number,
      default: 50
    },
    minHeight: {
      type: [Number, String],
      default: 57
    },
    innerClass: {
      type: [Array, String],
      default() {
        return [];
      }
    },
    useDefaultSlot: {
      type: Boolean,
      default: true
    },
    once: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      support: true,
      // isInit: false,
      timer: null,
      io: null,
      // loading: false,
      // leave: false
      inClient: false
    };
  },
  computed: {
    getStyle() {
      let style = {};
      if (this.minHeight) {
        style["min-height"] = this.unitSize(this.minHeight);
      }
      return style;
    },
    $innerClass() {
      let arr = [];
      if (dsf.isString(this.innerClass)) {
        return this.innerClass.join(" ");
      } else {
        arr = this.innerClass;
      }
      return arr;
    },
    $viewport() {
      if (this.isDesign) {
        return null;
      } else {
        if (!this.viewport) {
          return this?.$page?.$refs?.content;
        }
        return this.viewport;
      }
    }
    // inClient() {
    //   if (this.once) {
    //     return this.isInit;
    //   } else {
    //     return true;
    //   }
    // }
  },
  created() {
    if (!window.IntersectionObserver) {
      this.support = false;
    }
    if (this.support) {
      if (this.timeout) {
        this.timer = setTimeout(() => {
          this.enter();
        }, this.timeout);
      }
    }
  },
  mounted() {
    if (!this.support) {
      return;
    }
    if (!this.timeout) {
      this.start();
    }
  },
  beforeDestroy() {
    // 在组件销毁前取消观察
    if (this.io) {
      this.io.unobserve(this.$el);
    }
  },
  methods: {
    start() {
      let rootMargin;
      switch (this.direction) {
      case "vertical":
        rootMargin = this.unitSize(this.threshold) + " 0px";
        break;
      case "horizontal":
        rootMargin = "0px " + this.unitSize(this.threshold);
        break;
      }
      // 观察视口与组件容器的交叉情况
      this.io = new window.IntersectionObserver(this.intersectionHandler, {
        rootMargin,
        root: this.$viewport,
        threshold: [0, Number.MIN_VALUE, 0.01]
      });
      this.io.observe(this.$el);
    },
    // 交叉情况变化处理函数
    intersectionHandler(entries) {
      // 正在交叉
      let isIntersecting = entries[0].isIntersecting;
      // 交叉率大于0
      let intersectionRatio = entries[0].intersectionRatio;
      if (this.once) {
        if (isIntersecting || intersectionRatio) {
          this.enter();
          if (this.once) {
            this.io.unobserve(this.$el);
          }
        }
      } else {
        if (isIntersecting || intersectionRatio) {
          this.enter();
        } else if (!isIntersecting && !intersectionRatio) {
          this.leave();
        }
      }
    },
    leave() {
      this.$emit("before-init");
      // 此时可以准备加载懒加载组件的资源
      this.loading = false;

      // 由于函数会在主线程中执行，加载懒加载组件非常耗时，容易卡顿
      // 所以在requestAnimationFrame回调中延后执行
      this.requestAnimationFrame(() => {
        this.inClient = false;
        this.$emit("leave");
      });
    },
    // 处理组件和骨架组件的切换
    enter() {
      this.$emit("before-init");
      // 此时可以准备加载懒加载组件的资源
      this.loading = true;

      // 由于函数会在主线程中执行，加载懒加载组件非常耗时，容易卡顿
      // 所以在requestAnimationFrame回调中延后执行
      this.requestAnimationFrame(() => {
        this.inClient = true;
        this.$emit("enter");
      });
    },

    requestAnimationFrame(callback) {
      // 防止等待太久没有执行回调
      // 设置最大等待时间
      setTimeout(() => {
        if (this.inClient) return;
        callback();
      }, this.maxWaitingTime);

      // 兼容不支持requestAnimationFrame 的浏览器
      return (window.requestAnimationFrame || ((callback) => setTimeout(callback, 1000 / 60)))(callback);
    },
    beforeEnterHandler(el) {
      this.$emit("before-enter", el);
    },
    beforeLeaveHandler(el) {
      this.$emit("before-leave", el);
    },
    afterEnterHandler(el) {
      this.$emit("after-enter", el);
    },
    afterLeaveHandler(el) {
      this.$emit("after-leave", el);
    }
  }
});
</script>
